module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/invite-a-friend-eaabf21d6f35a41776f3b709b3d19af4.svg";